import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/components/common/messageservice';
import { ControllerManagerService } from '../../api/managers/controller-manager.service';
import { ControllerInfoForConfigDisplay } from '../../api/models/irrigation/ControllerInfoForConfigDisplay.model';
import { ControllerRecordChangeNotificationModel } from '../../api/models/notifications/controller-record-change-notification.model';

@Component({
    selector: 'app-config-viewer',
    templateUrl: './config-viewer.component.html',
    styleUrls: ['./config-viewer.component.less']
})
export class ConfigViewerComponent implements OnInit
{
    @Input() data: ControllerRecordChangeNotificationModel;

    controllerInfo: ControllerInfoForConfigDisplay;

    constructor(private controllerManager: ControllerManagerService,
                private messageService: MessageService) { }

    ngOnInit()
    {
        this.controllerManager.getControllerConfigDisplayInfo(this.data.ControllerId)
            .subscribe((controllerInfo: ControllerInfoForConfigDisplay) =>
            {
                this.controllerInfo = controllerInfo;
            }, error =>
            {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Unable to retrieve Controller Extended Information.' });
            });
    }

}
